var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66683C23.3099 2.66683 29.3337 8.7014 29.3337 15.9932C29.3337 23.2989 23.2959 29.3335 16.0003 29.3335C8.69075 29.3335 2.66699 23.2989 2.66699 15.9932C2.66699 8.7014 8.70473 2.66683 16.0003 2.66683Z",
    fill: "#282829",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9395 10.5873C12.5901 10.2521 12.5901 9.67936 12.9535 9.31616C13.261 9.02282 13.8759 9.03679 14.2114 9.35807L19.9696 14.8339C20.6404 15.4485 20.6404 16.5102 19.9696 17.1388L14.2114 22.6006C13.834 22.9498 13.3029 22.9778 12.9535 22.6425C12.5901 22.3073 12.5901 21.7206 12.9395 21.3853L18.6279 15.9933L12.9395 10.5873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.06af1e6028a98e1047ab21b45eaf00ca.svg";
export { ForwardRef as ReactComponent };